import { nanoid } from 'nanoid'

export const getSalt = () => nanoid(36)

// Legacy: URL-encode pipe-joined parts
export const buildRequestId = (salt, startTime, eventTypeUUID, ...identifiers) => {
  // Delimit values with '|' to remove transposition non-uniqueness
  const keyParts = [
    salt, startTime, eventTypeUUID, identifiers
  ].flat()

  return encodeURIComponent(keyParts.join('|'))
}

// New: URL-safe base64 (no padding)
export const buildRequestIdBase64 = (salt, startTime, eventTypeUUID, ...identifiers) => {
  const keyParts = [salt, startTime, eventTypeUUID, identifiers].flat()
  const raw = keyParts.join('|')
  const base64 = btoa(unescape(encodeURIComponent(raw)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '')
  return base64
}
